import React from 'react';
import HelpButton from "./HelpButton";
import {useExternalLink} from "../../externallink/ExternalLink";

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function DashboardHelpButton() {

    const dashboardHelpUrl = useExternalLink("dashboard-help");

    return (
        <HelpButton
            color='inherit'
            url={dashboardHelpUrl}
            windowTitle='Dashboard Help'
            style={squareHighlightStyle}
        />
    );
}
